import React from 'react';
import {
  useUserinfo,
  IconStartConnection,
  useAssetParams,
  useAssetConfig,
  useAssetQuery,
} from '@mss/mss-component-library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSlidersH,
  faProjectDiagram,
  faDesktop,
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import MssIcon from 'jsx/common/MssIcon';
import MssSidebar from 'jsx/common/Sidebar';
import Skeleton from '../../Skeleton';
import { useConfigurationQuery } from '../../../index';

const SidebarSkeleton = () => (
  <Skeleton className="w-100 h-[36px] mb-0.5 bg-gray-200" />
);

export default function Sidebar() {
  const { assetSubType, assetId } = useAssetParams();
  const [hasPermission] = useUserinfo(assetId);
  const [t] = useTranslation(['asset', 'common']);
  const { matchingConfig } = useAssetConfig(assetSubType);
  const { isLoading } = useAssetQuery(!matchingConfig);
  const { data: config } = useConfigurationQuery();
  const isISAE = assetSubType === 'isae';
  const isSiemensOPC =
    assetSubType === 'siemens_s7' || assetSubType === 'siemens_generic';
  const isFieldAsset = assetSubType === 'fieldprm';
  return (
    <MssSidebar>
      {isLoading && (
        <div className="mt-px">
          {[1, 2, 3, 4].map(x => (
            <SidebarSkeleton key={x} />
          ))}
        </div>
      )}
      {!isLoading && (
        <>
          <MssSidebar.Item
            title={t('Asset settings')}
            icon={<FontAwesomeIcon icon={faSlidersH} size={'sm'} />}
            url="asset-settings"
            data-ta="AssetSettings"
          />
          {hasPermission([
            'change_automationmonitorasset',
            'view_automationmonitorasset',
          ]) && (
              <MssSidebar.Item
                title={t('Monitor settings')}
                icon={<FontAwesomeIcon icon={faDesktop} size={'sm'} />}
                url="monitor-settings"
                data-ta="MonitorSettings"
              />
            )}
          {!matchingConfig.disableCollectors && (
            <MssSidebar.Item
              title={t('Collection settings')}
              icon={<FontAwesomeIcon icon={faProjectDiagram} size={'sm'} />}
              url="collection-settings"
              data-ta="CollectionSettings"
            />
          )}
          {!matchingConfig.disableRemoteAccess &&
            !config?.unidirectional &&
            hasPermission([
              'change_remoteprofile',
              'add_remoteprofile',
              'delete_remoteprofile',
              'view_remoteprofile',
            ]) && (
              <MssSidebar.Item
                title={t('Remote Settings')}
                icon={<MssIcon icon={IconStartConnection} className="mr-1" />}
                url="remote-profiles"
                data-ta="RemoteSettings"
              />
            )}
          {isISAE &&
            hasPermission(['change_assetmanagementapplicationisae']) && (
              <>
                <MssSidebar.Item
                  title={t('ISAE configuration')}
                  icon={<FontAwesomeIcon icon={faSlidersH} size={'sm'} />}
                  url="isae-configuration"
                  data-ta="ISAEConfiguration"
                />
              </>
            )}
          {isSiemensOPC &&
            hasPermission([
              'change_dcsplcassetsiemenss7',
              'change_dcsplcassetsiemensgeneric',
            ]) && (
              <MssSidebar.Item
                title={t('OPC Configuration')}
                icon={<FontAwesomeIcon icon={faSlidersH} size={'sm'} />}
                url="opc-configuration"
                data-ta="OPCConfiguration"
              />
            )}
          {isFieldAsset && (
            <MssSidebar.Item
              title={t('OPC Configuration')}
              icon={<FontAwesomeIcon icon={faSlidersH} size="sm" />}
              url="field-opc-configuration"
              data-ta="FieldOPCConfiguration"
            />
          )}
        </>
      )}
    </MssSidebar>
  );
}
